import { Trans, useLingui } from '@lingui/react'
import { shape, string } from 'prop-types'
import { connectStateResults } from 'react-instantsearch-dom'

import { PAGE_TYPE_SEARCH_RESULTS, TENANT_AT, TENANT_COM } from 'shared/consts'
import {
  EXPERIMENT_VARIATION,
  NEW_SEARCH_PAGE_LAYOUT_V3,
} from 'shared/experiments/consts'
import { getExperiment } from 'shared/experiments/utils/experiments'
import { isRebrandingCOMActive } from 'shared/experiments/utils/rebranding'
import IconCircleInfo from 'views/components/atoms/Icon/IconCircleInfo'
import IconCircleInfoOutline from 'views/components/atoms/Icon/IconCircleInfoOutline'
import ButtonTransparent from 'views/components/molecules/ButtonTransparent'
import Modal from 'views/components/molecules/Modal'
import ModalShowButton from 'views/components/molecules/ModalShowButton'
import Pagination from 'views/components/organisms/AlgoliaInstantSearch/Algolia/Pagination'
import Device from 'views/components/utils/Device'
import Tenant from 'views/components/utils/Tenant'
import TransWithHtml from 'views/components/utils/TransWithHtml'
import { usePageProperties } from 'views/utils/shopAndRuntimeConfigUtils'

import './FilterBox.scss'

import { FilterBoxSortingBar } from './FilterBoxSortingBar'

const FilterBox = props => {
  const { i18n } = useLingui()
  const { indexName } = props
  const { nbHits: total } = props.searchResults || {}

  const { experiments, pageType } = usePageProperties()

  const { variant } = getExperiment(NEW_SEARCH_PAGE_LAYOUT_V3, experiments)

  const isNewSearchLayoutV3Enabled =
    [EXPERIMENT_VARIATION.V1].includes(variant) &&
    pageType === PAGE_TYPE_SEARCH_RESULTS

  const isRebrandingCOMEnabled = isRebrandingCOMActive(experiments)

  return (
    <div className="e-FilterBox u-position--relative">
      <ul className="l-flex l-flex--wrap a-list-reset">
        <li>
          <span
            className="u-font-weight--bold u-color--grey e-FilterBox__title"
            data-qa-id="search-result-result-counter"
            suppressHydrationWarning
          >
            <Trans
              id="searchResults.label.totalResultsNumber"
              values={{ total }}
            />
          </span>
          <Tenant tenant={[TENANT_COM, TENANT_AT]}>
            {() => (
              <>
                <ModalShowButton
                  component={ButtonTransparent}
                  name="search-info"
                  small
                  modalId="search-info"
                  inline
                  className="u-margin-xx-small--left"
                >
                  {isRebrandingCOMEnabled ? (
                    <IconCircleInfoOutline
                      size="x-small"
                      className="u-color--grey"
                    />
                  ) : (
                    <IconCircleInfo size="x-small" className="u-color--grey" />
                  )}
                </ModalShowButton>
                <Modal
                  id="search-info"
                  className="e-SearchInfoModal"
                  title={<Trans id="searchResults.label.infoHeader" />}
                  isClientSideControlled
                  size="large"
                >
                  <TransWithHtml text={i18n._('searchResults.label.info')} />
                </Modal>
              </>
            )}
          </Tenant>
        </li>
      </ul>
      <Device desktop>
        {isNewSearchLayoutV3Enabled && (
          <div className="e-FilterBox__top-filters">
            <FilterBoxSortingBar indexName={indexName} />
            <Pagination scrollToTopAfterClick />
          </div>
        )}
      </Device>
    </div>
  )
}

FilterBox.propTypes = {
  searchResults: shape({}),
  indexName: string.isRequired,
}

FilterBox.defaultProps = {
  searchResults: null,
}

export default connectStateResults(FilterBox)
